module.exports = __webpack_public_path__ + "img/S1051440.05b72e74.jpg";